/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ErrorResponse,
  Language,
  LegalDocument,
  LegalDocumentDTO,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class LegalDocuments<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns the full HTML content of a legal document in the requested language; falls back to German when the requested language has no maintained value
   *
   * @tags Legal Documents
   * @name GetLegalDocument
   * @summary Get legal document
   * @request GET:/api/legal-documents/{document}/{language}
   * @secure
   */
  getLegalDocument = (
    document: LegalDocument,
    language: Language,
    params: RequestParams = {},
  ) =>
    this.request<LegalDocumentDTO, ErrorResponse | LegalDocumentDTO>({
      path: `/api/legal-documents/${document}/${language}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
